import reducers from '../TextField/TextField.reducers';

export default reducers;
